// components/Analytics/DevicePieChart.js
import { Chart } from 'primereact/chart';
import { getStableColor } from '../analyticsColors';

function PieChart({ data, config }) {

  if (!data || !data.labels || !data.datasets?.length) {
    return null;
  }
  const options = { maintainAspectRatio: false };

  const sourceDataset = data.datasets[0];

  const backgroundColor = data.labels.map((label) =>
    getStableColor(label)
  );

  const borderColor = data.labels.map(() =>
    '#ffffff'
  );


  const chartData = {
    labels: data.labels,

    datasets: [
      {
        ...sourceDataset,

        backgroundColor,
        borderColor,

        borderWidth: 2
      }
    ]
  };


  return (
    <Chart type="pie" data={chartData} options={options} className="h-[400px]" />
  );
}

export default PieChart;